import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import translateString from '../../utils/Locales';
import { NineCellLoading } from 'react-loadingg';
import getClient from '../../services/getClient';
import Cookies from 'universal-cookie';
import '../landingPage/style.css';
import sendMail from '../../services/sendMainEmail';
import { gonePremiumBody } from '../../utils/consts';

let t = translateString;

export default class OrderCompleted extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        
        const cookies = new Cookies();
        const db = cookies.get('db', { path: '/' });
        let cliente = await getClient('', '', db);

        if (cliente.type === '1') {
            await this.sendMail();
        }

        this.setState({ isLoading: false, cliente: cliente });
    }

    async sendMail() {
        const db = new Cookies().get('db', { path: '/' });
        let cliente = await getClient('', '', db);
        await sendMail(cliente.mail, cliente.ragioneSociale, t('ogg_premium'), gonePremiumBody(cliente.ragioneSociale));
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;
        return(
            <>
                <PageTitle title={t('grazie_ordine')} />
                { this.state.cliente.type === '1' && (
                    <div style={{ ...mainView }}>
                        <h4 style={{ fontWeight: 'bold' }}>{t('passato_account')} <span style={{ color: 'gold' }}>PREMIUM</span></h4>
                        <h6 style={{ fontWeight: 'bold', color: '#828282' }}>49 € {t('piu_iva')} {t('mese')}</h6>
                        <h6 style={{ marginTop: 30, fontWeight: 'normal', color: '#828282', fontSize: 16 }}>{t('grazie')}</h6>
                        <section style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: 25 }}>
                            <div className="btn btn-primary" onClick={() => window.location.href = '/' + new Cookies().get('db', { path: '/' }) + '/#/app/dashboard'} style={{marginTop: 8}}>{t('torna_home')}</div>
                            <div className="btn btn-primary" onClick={this.sendMail.bind(this)} style={{marginTop: 8, marginLeft: 10}}>{t('reinvia')}</div>
                        </section>
                    </div>
                )}
            </>
        );
    }
}

const mainView = {
    backgroundColor: 'white', 
    borderRadius: '10px', 
    padding: '30px',
    boxShadow: '0px 2px 10px lightgrey', 
    width: '90%',
}